// extracted by mini-css-extract-plugin
module.exports = {"separator":"tc9NIN7ZEfpIRARkNN9G2","button":"_1EJ7-iHP6tee6KCJuBw8Km","subtitle":"_2KH6oNn2n0f6-x4luXDJ76"};